class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.announcementBar = this.querySelector("#wt-announcement__container");
    this.announcementInterval = null;

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
    this.isMobileView = this.isMobileView.bind(this);
    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.handleTouchPauseStart = this.handleTouchPauseStart.bind(this);
    this.handleTouchPauseEnd = this.handleTouchPauseEnd.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.isPlaying = true;
  }

  connectedCallback() {
    if (
      !this.announcementBar?.classList.contains(
        "wt-announcement__container--marquee",
      )
    ) {
      this.announcementInterval = setInterval(this.changeAnnouncement, 5000);

      if (this.announcementBar) {
        this.announcementBar.addEventListener(
          "touchstart",
          this.handleTouchStart,
          { passive: true },
        );
        this.announcementBar.addEventListener(
          "touchmove",
          this.handleTouchMove,
          {
            passive: true,
          },
        );
        this.announcementBar.addEventListener("touchend", this.handleTouchEnd, {
          passive: true,
        });
        this.announcementBar.addEventListener(
          "touchstart",
          this.handleTouchPauseStart,
          { passive: true },
        );
        this.announcementBar.addEventListener(
          "touchend",
          this.handleTouchPauseEnd,
          {
            passive: true,
          },
        );
      }
    }

    if (this.announcementBar)
      this.announcementBar.style.transition = "transform 0.5s ease-in-out";

    this.playPauseButton = this.querySelector(".wt-announcement__play-pause");
    if (this.playPauseButton)
      this.playPauseButton.addEventListener("click", this.togglePlayPause);

    this.closeButton = this.querySelector(".wt-announcement__close");
    if (this.closeButton)
      this.closeButton.addEventListener("click", this.hideForOneDay);

    window.addEventListener("resize", this.handleResize);
  }

  handleResize() {
    if (window.innerWidth >= 900) {
      // Reset the translateX to its initial state
      if (this.announcementBar) {
        this.announcementBar.style.transform = "translateX(0)";
        this.currentIndex = 0;
      }
    }
  }

  isMobileView() {
    return window.innerWidth < 900;
  }

  restartInterval() {
    if (!this.isPlaying) return;

    clearInterval(this.announcementInterval);
    this.announcementInterval = setInterval(this.changeAnnouncement, 5000);
  }

  togglePlayPause() {
    this.isPlaying = !this.isPlaying;
    this.updatePlayPauseState();
  }

  updatePlayPauseState() {
    if (!this.playPauseButton) return;

    const pauseLabel = this.playPauseButton.dataset.labelPause;
    const playLabel = this.playPauseButton.dataset.labelPlay;

    if (this.isPlaying) {
      this.classList.remove("wt-announcement--paused");
      this.playPauseButton.classList.remove("wt-announcement__play-pause--paused");
      this.playPauseButton.classList.add("wt-announcement__play-pause--playing");
      this.playPauseButton.setAttribute("aria-label", pauseLabel);
      this.restartInterval();
    } else {
      this.classList.add("wt-announcement--paused");
      this.playPauseButton.classList.remove("wt-announcement__play-pause--playing");
      this.playPauseButton.classList.add("wt-announcement__play-pause--paused");
      this.playPauseButton.setAttribute("aria-label", playLabel);
      clearInterval(this.announcementInterval);
    }

    this.applyAnimationPlayState();
  }

  applyAnimationPlayState() {
    const playState = this.isPlaying ? "running" : "paused";

    this.querySelectorAll(".wt-announcement__marquee").forEach((marquee) => {
      marquee.style.animationPlayState = playState;
    });

    if (this.announcementBar?.classList.contains(
      "wt-announcement__container--animated",
    )) {
      this.announcementBar.style.animationPlayState = playState;
    }
  }

  handleTouchPauseStart() {
    if (this.isPlaying) clearInterval(this.announcementInterval);
  }

  handleTouchPauseEnd() {
    if (this.isPlaying) this.restartInterval();
  }

  hideForOneDay() {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
  }

  changeAnnouncement() {
    if (!this.isMobileView()) {
      return;
    }

    const totalSlides = this.announcementBar?.children.length;

    // Move to the next slide
    this.currentIndex = (this.currentIndex + 1) % totalSlides;
    const newPosition = -(this.currentIndex * 100);

    if (this.announcementBar)
      this.announcementBar.style.transform = `translateX(${newPosition}vw)`;

    if (this.currentIndex === 0 && this.announcementBar) {
      // When we're back at the start, reset position with transition.
      setTimeout(() => {
        this.announcementBar.style.transition = "none";
        this.announcementBar.style.transform = "translateX(0)";
        this.currentIndex = 0;
        // Restore transition after resetting position
        setTimeout(() => {
          this.announcementBar.style.transition = "transform 0.5s ease-in-out";
        }, 0);
      }, 490); // Just slightly before 0.5s to ensure it happens before next slide movement.
    }
  }

  previousAnnouncement() {
    const totalSlides = this.announcementBar?.children.length;

    this.currentIndex = (this.currentIndex - 1 + totalSlides) % totalSlides;
    const newPosition = -(this.currentIndex * 100);
    if (this.announcementBar)
      this.announcementBar.style.transform = `translateX(${newPosition}vw)`;
  }

  handleTouchStart(e) {
    if (this.isMobileView()) {
      this.touchStartX = e.touches[0].clientX;
    }
  }

  handleTouchMove(e) {
    if (this.isMobileView()) {
      this.touchEndX = e.touches[0].clientX;
    }
  }

  handleTouchEnd() {
    const swipeThreshold = 30;

    if (Math.abs(this.touchEndX - this.touchStartX) > swipeThreshold) {
      if (this.touchEndX < this.touchStartX) {
        this.changeAnnouncement();
      } else {
        this.previousAnnouncement();
      }
    }
  }

  disconnectedCallback() {
    clearInterval(this.announcementInterval);

    if (this.announcementBar) {
      this.announcementBar.removeEventListener(
        "touchstart",
        this.handleTouchStart,
      );
      this.announcementBar.removeEventListener(
        "touchmove",
        this.handleTouchMove,
      );
      this.announcementBar.removeEventListener("touchend", this.handleTouchEnd);
      this.announcementBar.removeEventListener(
        "touchstart",
        this.handleTouchPauseStart,
      );
      this.announcementBar.removeEventListener(
        "touchend",
        this.handleTouchPauseEnd,
      );
    }

    if (this.playPauseButton)
      this.playPauseButton.removeEventListener("click", this.togglePlayPause);

    if (this.closeButton)
      this.closeButton.removeEventListener("click", this.hideForOneDay);

    window.removeEventListener("resize", this.handleResize);
  }
}

customElements.define("announcement-bar", AnnouncementBar);
